import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';

const LabelledField = (props) => {
    const [divClass, setDivClass] = useState('');
    const [labelClass, setLabelClass] = useState('');
    const [spanClass, setSpanClass] = useState('');
    const [rejectedOrError, setRejectedOrError] = useState(false);

    useEffect(() => {
        setDivClass(props.alignment === 'columnLabel' ? 'columnLabel' : 'row');

        switch (props.alignment) {
            case 'columnLabel':
                setLabelClass('label col-4');
                setSpanClass('col-5');
                break;
            case 'leftLabel':
                setLabelClass('label col-6');
                setSpanClass('col-6');
                break;
            case 'leftLabelTight':
                setLabelClass('label col-7');
                setSpanClass('col-7');
                break;
            default:
                setLabelClass('label col-1');
                setSpanClass('col-2');
        }
    }, [props.alignment]);

    useEffect(() => {
        setRejectedOrError(props.text === 'Reject' || props.text === 'Rejetée' || props.text === 'Error' || props.text === 'Erreur')
    }, [props.text])

    return (
        <div className={divClass} >
            <label className={labelClass}>{props.label}</label>
            <span className={spanClass}
                style={rejectedOrError ? { fontWeight: 'bold', color: '#E70000' } : props.bold ? { fontWeight: 'bold' } : {}}>
                {props.text || " -"}
            </span>
        </div>
    )
}

LabelledField.propTypes = {
    label: PropTypes.string.isRequired,
    text: PropTypes.string,
    alignment: PropTypes.string,
    bold: PropTypes.bool
}

export default LabelledField;
